import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

// import { overviewFontBuilderCss } from '@/reports/teacher/components/common/OverviewDataResults/OverviewDataResults.style';

const { textXSObj } = typographyStyles;
const { mediaQuery: breakpoint } = mediaQueryStyles;

// const { ui } = constants.colors;
// const darkGrey700 = ui.neutral[700];
// const darkGrey500 = ui.neutral[600];

// export const breadcrumbContainerCss = {
//   marginBottom: '32px',
// };

// export const linkStyleCss = (isActive: boolean) => ({
//   a: {
//     textDecorationLine: isActive ? 'none' : 'underline',
//     color: isActive ? darkGrey700 : darkGrey500,
//     ...overviewFontBuilderCss({
//       fontSize: '12px',
//       fontStyle: 'normal',
//       fontWeight: '400',
//       lineHeight: '16px',
//     })
//   }
// });

// export const breadcrumbSeparatorCss = {
//   color: darkGrey700,
//   ...overviewFontBuilderCss({
//     fontSize: '12px',
//     fontStyle: 'normal',
//     fontWeight: '400',
//     lineHeight: '16px',
//   })
// };

export const breadcrumbsCss = [
  {
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.xs)]: {
      marginBottom: 12,
    },
  },
  textXSObj,
  {
    fontSize: "0.75rem",
    lineHeight: "1rem",
    "li > div > div": {
      zIndex: "1000",
    },
  },
  {
    '[aria-current="page"]': {
      textDecoration: "none",
    },
    "li:first-of-type > a": {
      textDecoration: "none",
    },
  },
];
